import { render, staticRenderFns } from "./RoomMessageColumn.vue?vue&type=template&id=4aa56b26&"
import script from "./RoomMessageColumn.vue?vue&type=script&lang=js&"
export * from "./RoomMessageColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports